function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.719 6.19c.155 0 .281.126.281.281v4.5a.281.281 0 01-.281.281h-4.5a.281.281 0 01-.282-.28v-.65c0-.158.13-.285.288-.281l2.963.07A4.592 4.592 0 0012 7.41a4.592 4.592 0 00-4.49 3.62.282.282 0 01-.275.223h-.67a.281.281 0 01-.277-.332 5.814 5.814 0 0110.555-2.132l-.055-2.31a.281.281 0 01.281-.288h.65zm-.284 6.562c.176 0 .31.16.277.333a5.814 5.814 0 01-10.555 2.132l.055 2.31a.281.281 0 01-.281.288h-.65A.281.281 0 016 17.534v-4.5c0-.156.126-.282.281-.282h4.5c.156 0 .281.126.281.282v.65c0 .157-.13.284-.287.28l-2.963-.07A4.592 4.592 0 0012 16.596a4.592 4.592 0 004.49-3.62.282.282 0 01.275-.224h.67z",
  fill: "currentColor",
  fillRule: "nonzero"
});

var SvgStatusRunningIcon = function SvgStatusRunningIcon(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgStatusRunningIcon;